import React, { useEffect, useState, useMemo } from 'react';
import { Dashboard } from './components/Dashboard';
import { MobileDashboard } from './components/MobileDashboard';
import { IDashboardDrawBudget } from '@apply/api/src/api/DrawApi';
import { isMobileScreen } from '@apply/ui';
import { DrawApi } from '@apply/api';
import { ApplicationStatusType } from '@apply/constants';
import { ApplyApi, DashboardLoansToClose, IDashboardApplicationItem } from '@apply/api/src/api/ApplyApi';
import { applicationInsights } from '../../../ApplicationInsights';
import { Greeting } from '../../../common_v2/components/Greeting';
import { useAuthentication } from '../../../Login/hooks/useAuthentication';

export const RegisteredApplicantDashboard: React.FC = () => {
    const applyApi = new ApplyApi(applicationInsights);
    const mobileScreen = isMobileScreen();
    const { authentication } = useAuthentication();

    const [inProgressApplications, set_inProgressApplications] = useState<IDashboardApplicationItem[]>([]);
    const [applicationsPendingApproval, set_applicationsPendingApproval] = useState<IDashboardApplicationItem[]>([]);
    const [loansReadyToClose, set_loansReadyToClose] = useState<DashboardLoansToClose[][]>([]);
    const [dashboardDrawBudgets, set_dashboardDrawBudgets] = useState<IDashboardDrawBudget[] | undefined>(undefined);
    const [loading, set_loading] = useState<boolean>(true);
    const drawApi = useMemo(() => new DrawApi.DrawApi(applicationInsights), [applicationInsights]);

    const loadApplicationData = async () => {
        const response = await drawApi.dashboardDrawBudgets();
        if (response.statusCode !== 200) {
            return;
        }
        const result = response.result;
        set_dashboardDrawBudgets(result);
    };

    const loadLoanData = async () => {
        const response = await applyApi.dashboardLoansToClose();
        if (response.statusCode !== 200) {
            return;
        }
        const result = response.result;
        set_loansReadyToClose(result);
    };

    useEffect(() => {
        const fetchData = async () => {
            loadApplications();
            loadApplicationData();
            loadLoanData();
        };
        fetchData();
        set_loading(false);
    }, []);

    const loadApplications = async () => {
        const response = await applyApi.dashboardApplications();

        if (response.statusCode !== 200) return;

        const [inProgress, submitted] = response.result.reduce(
            ([inProgress, submitted]: [IDashboardApplicationItem[], IDashboardApplicationItem[]], application) => {
                switch (application.applicationStatus) {
                    case ApplicationStatusType.Incomplete:
                        inProgress.push(application);
                        break;
                    default:
                        submitted.push(application);
                        break;
                }

                return [inProgress, submitted];
            },
            [[], []]
        );

        set_inProgressApplications(inProgress);
        set_applicationsPendingApproval(submitted);
    };

    const deleteApplication = async (applicationId: number) => {
        const response = await applyApi.deleteApplication(applicationId);

        if (response.statusCode !== 200) return;

        const newArray = inProgressApplications.filter((application) => application.applicationId !== applicationId);

        set_inProgressApplications(newArray);
    };

    return (
        <>
            <div className={isMobileScreen() ? 'mobilePadding' : ''}>
                <Greeting user={authentication?.user} />
            </div>
            {mobileScreen && (
                <MobileDashboard
                    inProgressApplications={inProgressApplications}
                    applicationsPendingApproval={applicationsPendingApproval}
                    loansReadyToClose={loansReadyToClose}
                    deleteApplication={deleteApplication}
                    dashboardDrawBudgets={dashboardDrawBudgets}
                    loading={loading}
                />
            )}
            {!mobileScreen && (
                <Dashboard
                    inProgressApplications={inProgressApplications}
                    applicationsPendingApproval={applicationsPendingApproval}
                    loansReadyToClose={loansReadyToClose}
                    deleteApplication={deleteApplication}
                    dashboardDrawBudgets={dashboardDrawBudgets}
                    loading={loading}
                />
            )}
        </>
    );
};
